var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeShown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5037 16.3327C15.9459 16.3327 19.6668 11.8817 19.6668 10.4993C19.6668 9.10977 15.9316 4.66602 10.5037 4.66602C5.14014 4.66602 1.3335 9.10977 1.3335 10.4993C1.3335 11.8817 5.14014 16.3327 10.5037 16.3327ZM10.5037 14.2917C8.41829 14.2917 6.76136 12.562 6.74708 10.4993C6.73994 8.37879 8.41829 6.7142 10.5037 6.7142C12.582 6.7142 14.2604 8.38603 14.2604 10.4993C14.2604 12.562 12.582 14.2917 10.5037 14.2917ZM10.5109 11.8817C11.2608 11.8817 11.8821 11.252 11.8821 10.4993C11.8821 9.73942 11.2608 9.10977 10.5109 9.10977C9.74669 9.10977 9.12534 9.73942 9.12534 10.4993C9.12534 11.252 9.74669 11.8817 10.5109 11.8817Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeShown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-shown.cccfb111d14fa5bd1c269798573b4eff.svg";